module.exports = __webpack_public_path__ + "static/ranger-01-b3a6cb7b9e5847a468c19232a0fade45.png";